import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 flex items-center justify-center px-6 py-12" }
const _hoisted_2 = { class: "max-w-md w-full text-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"mx-auto w-16 h-16 rounded-2xl bg-white border border-gray-200 shadow-sm flex items-center justify-center mb-6\"><svg viewBox=\"0 0 24 24\" class=\"w-8 h-8 text-gray-400\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" aria-hidden=\"true\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 9l1.5-5h15L21 9M3 9h18M3 9v11h18V9M9 20v-6h6v6\"></path></svg></div><h1 class=\"text-2xl font-bold text-gray-900\">Loja não encontrada</h1><p class=\"mt-2 text-gray-600\"> Não encontramos nenhuma loja neste endereço. Confira se o link está correto ou peça o endereço atualizado ao estabelecimento. </p>", 3)
const _hoisted_6 = {
  key: 0,
  class: "mt-4 inline-block px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-sm font-mono text-gray-700 break-all"
}
const _hoisted_7 = { class: "mt-10 p-6 rounded-2xl bg-white border border-gray-200 shadow-sm text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold uppercase tracking-wider text-gray-400" }, "Tem um restaurante, bar ou lanchonete?", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 text-lg font-bold text-gray-900" }, "Crie sua loja com cardápio digital", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", { class: "mt-3 space-y-1.5 text-sm text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("li", null, "• Cardápio digital com a cara da sua marca"),
  /*#__PURE__*/_createElementVNode("li", null, "• Pedidos de delivery, retirada e mesa direto no seu painel"),
  /*#__PURE__*/_createElementVNode("li", null, "• Seu endereço próprio na internet em poucos minutos")
], -1)
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.requestedAddress)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.requestedAddress), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("a", {
          href: _ctx.landingUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          class: "mt-5 w-full inline-flex items-center justify-center px-5 py-3 rounded-xl bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold transition-colors"
        }, " Quero ter minha loja ", 8, _hoisted_11)
      ])
    ])
  ]))
}